import { Pipe, PipeTransform } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Pipe({
  name: 'orderDetail'
})
export class OrderDetailPipe implements PipeTransform {

  constructor(private db: AngularFirestore) {}

  transform(value: any): any {
    return this.db.collection('orderDetail', detail => detail.where('fkOrder', '==', value.id)).valueChanges();
  }

}
